import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Drawer, Grid } from "@material-ui/core";
import DashboardIcon from "@material-ui/icons/Dashboard";
import SettingsIcon from "@material-ui/icons/Settings";

import { SidebarNav } from "./components";
import { inshs, itmes } from "../../../../../Context/Local";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import {
  Assessment,
  AssignmentReturn,
  Collections,
  Directions,
  MoveToInbox,
  Receipt,
} from "@material-ui/icons";
import { sto } from "../../../../../Context/InshData";
import SelectLanguage from "../../../../../components/SelectLanguage";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up("lg")]: {
      marginTop: 54,
      height: "calc(100% - 54px)",
    },
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  nav: {
    marginBottom: theme.spacing(2),
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, ...rest } = props;
  const { t } = useTranslation(["forms", "translation"]);

  const classes = useStyles();

  const pages = [
    {
      title: t("translation:dashboard"),
      href: "",
      icon: <DashboardIcon />,
    },
    {
      title: t("sales-invoice"),
      href: "Invoices",
      icon: <LocalMallIcon />,
      insh: inshs.Sales.sal,
      isAllow: sto.used_Nsale_screen,
    },
    {
      title: t("sales-return"),
      href: "Invoices",
      icon: <AssignmentReturn />,
      insh: inshs.Sales.salRet,
      isAllow: sto.used_Rsale_screen,
    },
    {
      title: t("translation:basic-product-data"),
      href: "products",
      icon: <Collections />,
      insh: itmes,
      isAllow: sto.used_Items_screen,
    },
    {
      title: t("daily_movement_report"),
      href: "ReporteveryDay",
      icon: <Assessment />,
      insh: "",
      isAllow: sto.used_Dialy_screen,
    },
    {
      title: t("shift_close_report"),
      href: "Shifts",
      icon: <Assessment />,
      insh: "",
      isAllow:sto.used_shifts_transClose??sto.used_Dialy_screen
    },
    {
      title: t("account-statement"),
      href: "HesabCustA",
      icon: <Assessment />,
      insh: inshs.Customers[2],
      isAllow: sto.used_Accnt_screen,
    },
    {
      title: t("store_inventory_report"),
      href: "ReportSafesJard",
      icon: <Assessment />,
      insh: "",
      isAllow: sto.used_Jarde_screen,
    },
    {
      title: t("external-receipt-voucher"),
      href: "ext-receipt",
      icon: <MoveToInbox />,
      insh: "",
      isAllow: sto.used_Sqabd_screen,
    },
    {
      title: t("external-exchange-voucher"),
      href: "ext-exchange",
      icon: <Directions />,
      insh: "",
      isAllow: sto.used_SSarf_screen,
    },
    // {
    //   title: "سند قبض داخلي",
    //   href: "int-receipt",
    //   icon: <MoveToInbox />,
    //   insh: "",
    //   isAllow: sto.used_Sqabd_screen,
    // },
    {
      title: t("internal-exchange-voucher"),
      href: "int-exchange",
      icon: <Directions />,
      insh: "",
      isAllow: sto.used_SSarf_screen,
    },
    {
      title: t("purchase-invoice"),
      href: "Invoices",
      icon: <LocalMallIcon />,
      insh: inshs.Purches.purch,
    isAllow: sto.used_purch_screen,

    },
    {
      title: t("purchase-return"),
      href: "Invoices",
      icon: <Collections />,
      insh: inshs.Purches.purchRet,
    isAllow: sto.used_Rpurch_screen,

    },
    {
      title: t("quotation-invoice"),
      href: "Invoices",
      icon: <Receipt />,
      insh: inshs.Sales.salViw,

      isAllow: sto.used_Nsale_screen,
    },
    {
      title: t("store-supply"),
      href: "store-supp",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_twreed_makhzni_screen??false,
    },
    {
      title: t("store-disburse"),
      href:  "store-exch",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_sarfe_mkhzni_screen??false,
    },
    {
      title: t("stock-settlement"),
      href:"reStore",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_tasweay_mkhzni_screen??false,
    },
    {
      title: t("store-receive"),
      href:"ReceiveST",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_estlam_mkhzni_screen??false,
    },
    {
      title: t("settings"),
      href: "settings",
      icon: <SettingsIcon />,
      isAllow: true,
    },

  ];

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        {/* <Divider className={classes.divider} /> */}
        <SidebarNav className={classes.nav} pages={pages} />

        {/* <UpgradePlan /> */}
      </div>
      <Grid container ex={12} justify="center">
        <SelectLanguage />
      </Grid>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
